// extracted by mini-css-extract-plugin
export default {"notfound":"PageNotFound_notfound__z9IO4","notfound_content":"PageNotFound_notfound_content__2DlNv"};